import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { darkTheme, lightTheme } from '../styles/theme';

const ThemeToggleContext = createContext({ mode: 'dark', toggle: () => {} });

export const useThemeMode = () => useContext(ThemeToggleContext);

export function AppThemeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    if (typeof window === 'undefined') return 'dark';
    return localStorage.getItem('theme_mode') || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('theme_mode', mode);
  }, [mode]);

  const value = useMemo(
    () => ({
      mode,
      toggle: () => setMode((m) => (m === 'dark' ? 'light' : 'dark')),
      setMode,
    }),
    [mode]
  );

  const currentTheme = mode === 'dark' ? darkTheme : lightTheme;

  return (
    <ThemeToggleContext.Provider value={value}>
      <SCThemeProvider theme={currentTheme}>{children}</SCThemeProvider>
    </ThemeToggleContext.Provider>
  );
}
